import type { ProgramBlock } from '@/components/UI/Timetable/types';

export const SELECT_DROPDOWN_STYLES = { zIndex: 99999 };

export enum ProgramStatusColors {
  待審核 = '#606060',
  待上架 = '#939393',
  已上架 = '#E08235',
  報名中 = '#EFC650',
  已開成 = '#95951D',
  已結束 = '#29619B',
}

// TODO: 從這行註解往下的都是測試用資料，記得改成真實資料，並刪除測試用資料
export const TEACHER_OPTIONS = [
  {
    label: '王大明',
    value: '王大明',
  },
  {
    label: '李小華',
    value: '李小華',
  },
  {
    label: '張美玲',
    value: '張美玲',
  },
  {
    label: '陳志明',
    value: '陳志明',
  },
  {
    label: '林雅婷',
    value: '林雅婷',
  },
  {
    label: '黃建國',
    value: '黃建國',
  },
  {
    label: '吳淑芬',
    value: '吳淑芬',
  },
  {
    label: '劉俊宏',
    value: '劉俊宏',
  },
  {
    label: '蔡佳玲',
    value: '蔡佳玲',
  },
  {
    label: '楊志豪',
    value: '楊志豪',
  },
];

export const DUMMY_SCHEDULE_DATA: (Omit<ProgramBlock, 'backgroundColor'> & {
  status: keyof typeof ProgramStatusColors;
})[] = [
  {
    id: '1',
    label: '底層1號',
    instructor: '王大明',
    venue: '健身房A',
    address: '',
    columnIdx: 0,
    start: '09:00',
    end: '12:00',
    status: '報名中',
  },
  {
    id: '2',
    label: '底層2號',
    instructor: '李小華',
    venue: '瑜珈教室',
    address: '',
    columnIdx: 0,
    start: '09:30',
    end: '12:30',
    status: '已上架',
  },
  {
    id: '3',
    label: '底層3號',
    instructor: '張美玲',
    venue: '舞蹈室',
    address: '',
    columnIdx: 0,
    start: '10:00',
    end: '13:00',
    status: '已結束',
  },
  {
    id: '4',
    label: '底層4號',
    instructor: '陳志明',
    venue: '健身房B',
    address: '',
    columnIdx: 0,
    start: '10:30',
    end: '13:30',
    status: '待審核',
  },
  {
    id: '5',
    label: '底層5號',
    instructor: '林雅婷',
    venue: '游泳池',
    address: '',
    columnIdx: 0,
    start: '11:15',
    end: '14:15',
    status: '待上架',
  },
  {
    id: '6',
    label: '測試單一區塊',
    instructor: '黃建國',
    venue: '其他',
    address: '台北市大安區忠孝東路四段100號5樓',
    columnIdx: 0,
    start: '11:00',
    end: '12:00',
    status: '已上架',
  },
  {
    id: '7',
    label: '群組區塊A',
    instructor: '吳淑芬',
    venue: '教室A',
    address: '',
    columnIdx: 0,
    start: '13:30',
    end: '15:30',
    status: '報名中',
  },
  {
    id: '8',
    label: '群組區塊B',
    instructor: '劉俊宏',
    venue: '教室B',
    address: '',
    columnIdx: 0,
    start: '14:30',
    end: '15:45',
    status: '已開成',
  },
  {
    id: '9',
    label: '群組區塊C',
    instructor: '蔡佳玲',
    venue: '教室C',
    address: '',
    columnIdx: 0,
    start: '14:45',
    end: '16:00',
    status: '已結束',
  },
  {
    id: '16',
    label: '測試單一區塊2',
    instructor: '楊志豪',
    venue: '特殊教室2',
    address: '',
    columnIdx: 0,
    start: '13:15',
    end: '14:15',
    status: '待審核',
  },
  {
    id: '17',
    label: '測試單一區塊3',
    instructor: '王大明',
    venue: '特殊教室3',
    address: '',
    columnIdx: 0,
    start: '11:15',
    end: '12:15',
    status: '待上架',
  },
  {
    id: '10',
    label: '正常課程1',
    instructor: '李小華',
    venue: '皮拉提斯教室',
    address: '',
    columnIdx: 2,
    start: '15:00',
    end: '17:45',
    status: '已上架',
  },
  {
    id: '11',
    label: '正常課程2',
    instructor: '張美玲',
    venue: '舞蹈教室',
    address: '',
    columnIdx: 2,
    start: '13:15',
    end: '15:30',
    status: '報名中',
  },
  {
    id: '12',
    label: '同時開始1',
    instructor: '陳志明',
    venue: '測試場地1',
    address: '',
    columnIdx: 1,
    start: '21:00',
    end: '22:00',
    status: '已開成',
  },
  {
    id: '13',
    label: '同時開始2',
    instructor: '林雅婷',
    venue: '測試場地2',
    address: '',
    columnIdx: 1,
    start: '21:00',
    end: '22:30',
    status: '已結束',
  },
  {
    id: '14',
    label: '同時開始3',
    instructor: '黃建國',
    venue: '測試場地3',
    address: '',
    columnIdx: 1,
    start: '21:00',
    end: '23:00',
    status: '待審核',
  },
  {
    id: '15',
    label: '同時開始4',
    instructor: '吳淑芬',
    venue: '測試場地4',
    address: '',
    columnIdx: 1,
    start: '21:00',
    end: '21:30',
    status: '待上架',
  },
  {
    id: '18',
    label: '5分鐘短時',
    instructor: '劉俊宏',
    venue: '短時場地',
    address: '',
    columnIdx: 1,
    start: '11:00',
    end: '11:05',
    status: '已上架',
  },
  {
    id: '19',
    label: '四點AM',
    instructor: '蔡佳玲',
    venue: '早四場地',
    address: '',
    columnIdx: 1,
    start: '04:00',
    end: '06:15',
    status: '已上架',
  },
];
